module.exports = {
    ErrorCode: {
        Success: 0,
        Empty: 1,
        CookieInvalid: 1101
    },
    Subject: {
        1: '语文',
        2: '数学',
        3: '英语',
        4: '物理',
        5: '化学',
        6: '生物',
        7: '政治',
        8: '历史',
        9: '地理',
        10: '奥数'
    },
    WeekDay: {
        0: '星期日',
        1: '星期一',
        2: '星期二',
        3: '星期三',
        4: '星期四',
        5: '星期五',
        6: '星期六'
    },
    Grade: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        11: '小学一年级',
        12: '小学二年级',
        13: '小学三年级',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下',
        1: '小学',
        2: '初中',
        3: '高中'
    },
    Grade2: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        32: '高二文',
        33: '高二理',
        34: '高三文',
        35: '高三理',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    Grade3: {
        21: '初一',
        22: '初二',
        23: '初三',
        24: '初四',
        31: '高一',
        36: '高二',
        37: '高三',
        14: '小学四年级',
        15: '小学五年级',
        16: '小学六年级',
        17: '小学三年级以下'
    },
    TransactionStatus: {
        1: '处理中',
        2: '支付成功',
        3: '支付失败',
        4: '交易关闭',
        5: '取消充值'
    },
    GoodsType: {
        1: '学费',
        2: '学豆'
    },
    PayThrough: {
        1: '学费余额',
        11: '支付宝',
        12: '支付宝',
        13: '支付宝',
        14: '花呗分期',
        97: '支付宝',
        21: '微信',
        22: '微信',
        23: '微信',
        24: '微信',
        25: '微信',
        26: '微信',
        27: '微信',
        31: '财付通',
        41: '慧学空间',
        51: '课时置换',
        52: '课时变更',
        61: '民生银行',
        71: '度小满金融',
        95: '银联',
        96: '银联',
        98: '旧平台',
        99: '未知'
    },
    LessonType: {
        // 试听
        FREE_LESSON: 1,
        // 课时计划
        FORMAL_LESSON: 2,
        // 答疑课
        QA_LESSON: 3
    },
    // 标准课时包等级
    StandardClassPackageLevel: {
        1: '基础',
        2: '高级',
        3: 'VIP'
    },
    // 课时记录类型
    PeriodRecordType: {
        1: '一般课时包',
        2: '标准课时包',
        3: '标准课时包升级',
        4: '订单'
    }
};



// WEBPACK FOOTER //
// ./src/constants/enum.js